import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  ManagementContentService,
  ThasService,
  UserActivityService,
} from '../features/admin/_services';
import { environment } from '../environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
  selector: 'edu-root',
  template: `<router-outlet />`,
})
export class AppComponent {
  readonly #contentService = inject(ManagementContentService);

  readonly #userActivityService = inject(UserActivityService);

  readonly #thasService = inject(ThasService);

  constructor() {
    this.#userActivityService.initialize();
    this.#thasService.initialize();

    if (environment.localParsingEnabled) {
      this.#contentService.enableLocalParsing();
    }
  }
}
